import type { ProactiveProposalStatus, Role } from './types';

export interface VendorPortalAuthState {
  authenticated: boolean;
  role: Role | null;
  vendor_id: string | null;
}

export function shouldSkipVendorEmailVerification(state: VendorPortalAuthState): boolean {
  return state.authenticated && state.role === 'VENDOR' && Boolean(state.vendor_id);
}

export function vendorProposalAccessMessage(status: string | null | undefined): string | null {
  if (status === 'ACTIVE') return null;
  if (status === 'SUSPENDED')
    return '目前廠商狀態為暫停交易，暫時無法新增新品提案，請聯繫採購人員。';
  return '此廠商帳號目前已停用，無法建立新品提案。';
}

export function canCreateVendorProposal(status: string | null | undefined): boolean {
  return status === 'ACTIVE';
}

export function canContinueVendorApplicationProposal(
  status: string | null | undefined,
  reviewAction: string | null | undefined,
): boolean {
  if (status === 'DRAFT' || status === 'PENDING_REVIEW' || status === 'APPROVED') return true;
  return (
    status === 'REJECTED' && ['REQUEST_DOCUMENTS', 'RETURN_FOR_EDIT'].includes(reviewAction ?? '')
  );
}

export function publicVendorProposalStatus(
  status: ProactiveProposalStatus,
  vendorApprovalPending: boolean,
): ProactiveProposalStatus {
  return vendorApprovalPending && status === 'SUBMITTED' ? 'WAITING_VENDOR_APPROVAL' : status;
}
